import {
    call,
    take,
    select
} from 'redux-saga/effects';
import {
    PAGINATE
} from '../actions/paginationActions';
import {
    beginRequestSaga
} from './categoryInitialSagas';

export function *paginateSaga() {
    let payload = {};

    // eslint-disable-next-line no-cond-assign
    while ({ payload } = yield take(PAGINATE)) {
        let state = yield select();

        yield call(
            beginRequestSaga,
            payload.page,
            payload.requestType,
            state.category.categorySlug,
            state.category.searchTerm,
            payload.queryString
        );
    }
}

export default [
    paginateSaga
];
